// extracted by mini-css-extract-plugin
module.exports = {"head":"Services_head__uthwa","stage":"Services_stage__3tOQI","title":"Services_title__3BEtJ","list":"Services_list__2d6gZ","item":"Services_item__zET41"};